import React from 'react';
import { Link } from 'react-router-dom';
import { IoLogoInstagram } from 'react-icons/io5';
import { MdEmail } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';
import './Footer2.css';
import { ToastContainer } from 'react-toastify';

const Footer2 = () => {
    return (

        <footer className="footer2-wrapper">
            <div className="footer2-container">
                <div className="footer2-content">
                    {/* Left Section - Policy Links */}
                    <div className="footer2-links">
                        <Link to='/privacy'>Privacy Policy</Link>
                        <span className="footer2-separator">|</span>
                        <Link to='/terms'>Terms & Conditions</Link>
                        <span className="footer2-separator">|</span>
                        <Link to='/shoppingterms'>Shopping Terms</Link>
                        <span className="footer2-separator">|</span>
                        <Link to='/faq'>FAQ</Link>
                        {/* <span className="footer2-separator">|</span>
                        <Link to='/bio'>About</Link> */}
                    </div>

                    {/* Right Section - Social Icons */}
                    <div className="footer2-icons">
                        <a
                            href="https://www.instagram.com/vvdesign.studio_?igsh=NGVodDA0amhmbXgw"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="instagram"
                            aria-label="Instagram"
                        >
                            <IoLogoInstagram />
                        </a>
                        <a
                            href="https://mail.google.com/mail/?view=cm&to=vvdesign.64@gmail.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="email"
                            aria-label="Email"
                        >
                            <MdEmail />
                        </a>
                        <a
                            href="https://wa.me/917984785574?text=Hello%2C%20I%20would%20like%20to%20discuss%20your%20products."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp"
                            aria-label="WhatsApp"
                        >
                            <FaWhatsapp />
                        </a>
                    </div>
                </div>
            </div>
        </footer>

    );
};

export default Footer2;